import Tabz from '@mui/material/Tabs';
import React, { CSSProperties } from 'react';
import { bluePlanetTheme } from 'ui/theme';

interface Props<T> {
  className?: string;
  activeTab: T;
  onChange?: (activeTab: T, e: React.ChangeEvent<object>) => void;
  children: React.ReactNode;
  hideTabIndicator?: boolean;
  align?: 'left' | 'right';
  style?: CSSProperties;
  variant?: 'fullWidth' | 'scrollable';
  type?: 'rounded' | 'underlined';
}

export default function Tabs<T>(props: Props<T>) {
  const isUnderlined = props.type === 'underlined';

  return (
    <Tabz
      variant={props.variant ?? 'scrollable'}
      value={props.activeTab}
      className={props.className}
      textColor="primary"
      indicatorColor="primary"
      allowScrollButtonsMobile
      onChange={(e, activeTab) => props.onChange && props.onChange(activeTab, e)}
      TabIndicatorProps={{ hidden: props.hideTabIndicator }}
      scrollButtons="auto"
      style={props.style}
      sx={{
        maxWidth: '100%',
        '.MuiTabs-flexContainer': {
          maxWidth: '100%',
          justifyContent: props.align === 'right' ? 'flex-end' : undefined,
        },
        // Override the theme indicator styles when using underlined type
        ...(isUnderlined && {
          borderBottom: `1px solid ${bluePlanetTheme.bluePlanetPalette.grey.medium}`,
          '& .MuiTabs-indicator': {
            display: 'block',
            height: '2px',
            backgroundColor: bluePlanetTheme.bluePlanetPalette.blue.main,
            borderRadius: 0,
            bottom: 0,
            top: 'auto',
          },
        }),
      }}
    >
      {props.children}
    </Tabz>
  );
}
